import Component from 'vue-class-component';
import { VueWizard } from '@/vue-wizard';
import RegisterViewsHolder from '@/app/components/register-views-holder/RegisterViewsHolder.vue';
import TabsViewManager from "@/app/components/tabs-view-manager/TabsViewManager.vue";
import Swal from "sweetalert2";
const _ = require('lodash');

@Component({
    name: 'Register',
    components: {
        RegisterViewsHolder, TabsViewManager
    }
})

export default class Register extends VueWizard {

    public validInfo = false;
    public loading = false;

    async mounted() {
        const urlID = this.$route.params.id;
        this.loading = true
        await this.$store.dispatch('getUserInfo', urlID)
            .then(() => this.validInfo = true)
            .catch(async () => {
                this.validInfo = false;
                await this.$router.push('/')
                await Swal.fire({
                    title: "Error al validar URL!",
                    icon: "error",
                    html: `Esta URL es invalída`,
                    showCloseButton: false,
                    showCancelButton: false,
                    focusConfirm: false,
                    heightAuto: false,
                })
            }).finally(() => this.loading = false)
    }

    get registerActions() {
        return _.cloneDeep(this.$store.state.registerActions);
    }

    get currentActionIndex() {
        return _.cloneDeep(this.$store.state.currentActionIndex);
    }

}
